/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './upsertSet.defs.js'
export { main as default } from './upsertSet.defs.js'
